import * as types from '../actions/types';
import * as request from '../utils/request';
import toastr from 'toastr';

export function changePasswordSuccess() {
  return( {type: types.CHANGE_PASSWORD_SUCCESS})
}

export function getDeansSuccess(data) {
  return({
    type: types.GET_DEANS_SUCCESS,
    payload: data
  })
}

export function changePassword(values) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request.req('POST', '/runs/'+runName+'/change-password/', values)
        .then(() => {
          toastr.success('Password was changed successfully.');
          dispatch(changePasswordSuccess());
          return resolve();
        }).catch(err => {
        console.log('ERROR PASSWORD CHANGE', err);
        toastr.error('Password was not changed.');
        return reject();
      });
    });
    return promise;
  }
}

export function getDeans() {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    request.req('GET', '/runs/' + runName + '/deans/')
      .then(res => {
        dispatch(getDeansSuccess(res.data.results));
      }).catch(err => {
        console.log('ERROR GETTING DEANS', err);
    });
  }
}

export function addAdmin(adminsArray) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let promises = [];
      adminsArray.map(admin => {
        let obj = {
          user: {
            email: admin.email
          }
        };
        promises.push(request.req('POST', '/runs/' + runName + '/deans/', obj));
      });
      Promise.all(promises).then(() => {
        toastr.success('Admin(s) added successfully');
        return resolve();
      }).catch(err => {
        console.log('err', err);
        toastr.error('Error');
        return reject();
      });
    });
    return promise;
  }
}

export function deleteDean(id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request.req('DELETE', '/runs/'+runName+'/deans/'+id+'/')
        .then(() => {
          toastr.success('Admin is deleted successfully');
          return resolve();
        }).catch((err) => {
        console.log(err);
        toastr.error('Something gone wrong');
        return reject();
      });
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/actions/profileActionCreators.js